import { render } from "./MfaEmail.vue?vue&type=template&id=0cfa962c&scoped=true"
import script from "./MfaEmail.vue?vue&type=script&lang=js"
export * from "./MfaEmail.vue?vue&type=script&lang=js"

import "./MfaEmail.vue?vue&type=style&index=0&id=0cfa962c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfa962c"]])

export default __exports__